import React, { useEffect, useState } from "react";
import Bmi from "./Bmi";
import { Divider } from "antd";
import NutritionistInvestigations from "./NutritionistInvestigations";
import NutritionalScreeningRating from "./NutritionalScreeningRating";
import NutritionalRisk from "./NutritionalRisk";
import { NutritionistInitialContext } from "../HistoryForm/NutritionistInitialAssessmentProvider";

const NutritionistClinicalEvaluationForm = ({
  form,
  formData,
  patientData,
}) => {
  const [, setRefresh] = useState(false);
  useEffect(() => {
    form.setFieldsValue(formData?.clinical_evaluation);
    setTimeout(() => setRefresh((prev) => !prev), 1000);
  }, [formData]);
  return (
    <>
      <Bmi
        context={NutritionistInitialContext}
        gender={patientData?.admission?.patient?.gender}
        form={form}
        data={formData}
      />
      <Divider />
      <NutritionistInvestigations />
      <Divider />
      <NutritionalScreeningRating form={form} />
      <Divider />
      <NutritionalRisk context={NutritionistInitialContext} form={form} />
    </>
  );
};

export default NutritionistClinicalEvaluationForm;
